var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3879"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image 1",
    x: 1.46484,
    y: 0.5,
    width: 38.9412,
    height: 39,
    rx: 3.5,
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M13.5145 14.6106C14.7359 15.3801 17.637 16.6421 19.4692 15.534C21.3015 14.426 21.1488 12.9177 20.8434 12.3021C20.2327 11.8404 18.7363 11.5634 17.637 14.1489C16.2628 17.3809 15.8048 23.383 14.8886 25.2298C13.9725 27.0766 13.5145 28 12.1403 28C10.7661 28 10.7661 26.6149 11.2242 26.1532C11.6822 25.6915 12.5984 24.3064 15.8048 25.6915C19.0112 27.0766 21.3015 27.0766 24.0499 27.5383C26.2486 27.9077 29.5466 27.0766 30.9208 26.6149",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningWord);
export default __webpack_public_path__ + "static/media/learning-word.8dae6466.svg";
export { ForwardRef as ReactComponent };